export default "__VITE_ASSET__BeE8ZcrV__"